module.exports = __webpack_public_path__ + "img/рз_29.c9ebe530.png";